// Choose which shared folder on a PC to open (when the host has more than one).
import type { PCInfo } from '../api';

export interface FolderPickerProps {
  pc: PCInfo;
  onSelect: (folder: { path: string; name: string }) => void;
  onBack: () => void;
}

export function FolderPicker({ pc, onSelect, onBack }: FolderPickerProps): JSX.Element {
  return (
    <div className="drive-screen">
      <div className="drive-screen-head">
        <button type="button" className="btn ghost drive-back-link" onClick={onBack}>
          ← All drives
        </button>
        <h2 className="drive-screen-title">{pc.name}</h2>
        <p className="drive-screen-sub">Choose a shared folder to open on this PC.</p>
      </div>
      {pc.folders.length === 0 ? (
        <div className="drive-empty">
          <p>No folders are shared with you on this PC yet.</p>
        </div>
      ) : (
        <ul className="drive-host-list">
          {pc.folders.map((folder) => (
            <li key={folder.path}>
              <button
                type="button"
                className="drive-host-card"
                onClick={() => onSelect(folder)}
              >
                <span className="drive-host-icon" aria-hidden>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 7h8l2 2h8v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      fill="#e8f0fe"
                    />
                  </svg>
                </span>
                <span className="drive-host-body">
                  <span className="drive-host-name">{folder.name}</span>
                </span>
                <span className="drive-host-chevron" aria-hidden>›</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
